// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Запити на відрядження» (Travel requests, ключ `travel`, група `office`). */
export const travelRequestsManifest: IModuleManifest = {
  key: 'travel',
  group: 'office',
  slug: 'travel-requests',
  prefix: 'TRV',
  name: { en: 'Travel requests', uk: 'Запити на відрядження' },
  entities: [
    { key: 'travel', slug: 'travel', name: { en: 'Travel requests', uk: 'Запити на відрядження' }, main: true },
    { key: 'trip_traveller', slug: 'trip-traveller', name: { en: 'Trip Travellers', uk: 'Учасники поїздки' }, main: false },
    { key: 'trip_booking', slug: 'trip-booking', name: { en: 'Trip Bookings', uk: 'Бронювання' }, main: false },
    { key: 'trip_expense', slug: 'trip-expense', name: { en: 'Trip Expenses', uk: 'Видатки' }, main: false },
    { key: 'trip_approval', slug: 'trip-approval', name: { en: 'Trip Approvals', uk: 'Погодження' }, main: false },
    { key: 'trip_status', slug: 'trip-status', name: { en: 'Trip Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/travelRequestsSlice').then((m) => m.travelRequestsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
